import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { authActions } from '_store';
import { fetchWrapper } from '_helpers';
//import { ResetPassword } from 'views/account/ResetPassword';

// create slice

const name = 'users';
const initialState = createInitialState();
const extraActions = createExtraActions();
const reducers = createReducers();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports

export const userActions = { ...slice.actions, ...extraActions };
export const usersReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        list: null,
        item: null,
        isLoading: false
    }
}

function createReducers() {
    return {
        setUser
    };

    function setUser(state, action) {
        state.item = action.payload;
    }

}

function createExtraActions() {
    const baseUrl = process.env.REACT_APP_API_URL;

    return {
        register: register(),
        getAll: getAll(),
        update: update(),
        delete: _delete(),
        resetPassword: resetPassword()
    };

    function register() {
        return createAsyncThunk(
            `${name}/register`,
            async (user) => await fetchWrapper.post(`${baseUrl}/user`, user)
        );
    }

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async () => await fetchWrapper.get(`${baseUrl}/users`)
        );
    }

    function update() {
        return createAsyncThunk(
            `${name}/update`,
            async function ({ username, data }, { getState, dispatch }) {
                await fetchWrapper.put(`${baseUrl}/user/${username}`, data);

                // update stored user if the logged in user updated their own record
                const auth = getState().auth.value;
                if (username === auth?.username) {
                    // update local storage and store
                    const user = { ...auth, ...data };
                    localStorage.setItem('auth', JSON.stringify(user));
                    dispatch(userActions.setUser(user))
                    // update auth user in redux state
                    dispatch(authActions.setAuth(user));
                }
            }
        );
    }

    // prefixed with underscore because delete is a reserved word in javascript
    function _delete() {
        return createAsyncThunk(
            `${name}/delete`,
            async function (username, { getState, dispatch }) {
                await fetchWrapper.delete(`${baseUrl}/user/${username}`);

                // auto logout if the logged in user deleted their own record
                // should not happen !!
                if (username === getState().auth.value?.username) {
                    dispatch(authActions.logout());
                }
            }
        );
    }

    function resetPassword() {
        return createAsyncThunk(//todo tester
            `${name}/resetPassword`,
            async (user) => await fetchWrapper.get(`${baseUrl}/new_password/${user.username}`)
        );
    }
}

function createExtraReducers() {
    return (builder) => {
        getAll();
        _delete();

        function getAll() {
            var { pending, fulfilled, rejected } = extraActions.getAll;
            builder
                .addCase(pending, (state) => {
                    state.isLoading = true;
                    state.list = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.isLoading = false;
                    state.list = { value: action.payload };
                })
                .addCase(rejected, (state, action) => {
                    state.isLoading = false;
                    state.list = { error: action.error };
                });
        }

        function _delete() {
            var { pending, fulfilled, rejected } = extraActions.delete;
            builder
                .addCase(pending, (state, action) => {
                    state.isLoading = true;
                    const user = state.list.value.find(x => x.username === action.meta.arg);
                    user.isDeleting = true;
                })
                .addCase(fulfilled, (state, action) => {
                    state.isLoading = false;
                    state.list.value = state.list.value.filter(x => x.username !== action.meta.arg);
                })
                .addCase(rejected, (state, action) => {
                    state.isLoading = false;
                    const user = state.list.value.find(x => x.username === action.meta.arg);
                    user.isDeleting = false;
                });
        }
    }
}
